import { openDocumentWindow } from "client/Features/Documents/DocumentWindow";
import { OpenInNewWorkspaceTabModel } from "client/Api/Documents/common";

function init(model: OpenInNewWorkspaceTabModel) {
	openDocumentWindow({
		file: {
			name: model.fileName
		},
		url: model.openWacModel.url,
		version: model.openWacModel.version,
		shouldHideRibbon: false,
		editorMode: model.openWacModel.editorMode,
		onClose: function () {
			window.close();
		},
		isResizable: false
	});
}

export {
	init
};
